import { useContextState } from "../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        cells: {
            padding: '16px 3px',
            borderRadius: '4px',
            textAlign: 'center',
            minHeight: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '.875rem'
        },
        colInitial: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            overflow: 'hidden',
        },
        titles: {
            overflow: 'hidden',
            flex: 1,
            color: colors.color10,
            fontWeight: 500,
        },
        containerCollapse: {
            mt: '8px',
            ml: '8px',
            mb: '8px',
            background: colors.color44,
            borderRadius: '6px'
        },
        secondaryCollapse: {
            mt: '8px',
            ml: '8px',
            mb: '8px',
            background: 'transparent',
            borderRadius: 0
        },
        secondaryTable: {
            width: '100%',
            tableLayout: 'fixed',
            background: 'transparent'
        }
    }
}

export default useStyles